import FIELDS_TO_BE_SKIPED from '../const';

export const removeInternalValues = (obj: any): any => {
  if (obj === null || obj === undefined) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(item => removeInternalValues(item));
  }

  if (typeof obj === 'object') {
    const cleaned: any = {};
    for (const key in obj) {
      if (
        ![
          FIELDS_TO_BE_SKIPED.FORM_DISPLAY_VALUE_FIELD,
          FIELDS_TO_BE_SKIPED.FORM_LOCAL_FIELD,
          FIELDS_TO_BE_SKIPED.FORM_META,
          FIELDS_TO_BE_SKIPED.MODEL_VERSION_ID,
          FIELDS_TO_BE_SKIPED.MODEL_ID,
        ].includes(key as any) &&
        obj.hasOwnProperty(key)
      ) {
        cleaned[key] = removeInternalValues(obj[key]);
      }
    }
    return cleaned;
  }

  return obj;
};
